import { useEffect, useState } from "react";
import axios from "axios";
import { getApiUrl } from "@/utils/api";

const API = getApiUrl();

let cachedToggles = null;
let inFlight = null;
const listeners = new Set();

function fetchToggles() {
  if (!inFlight) {
    inFlight = axios
      .get(`${API}/public/integrations/visibility`)
      .then(({ data }) => {
        cachedToggles = data.toggles || {};
        listeners.forEach((fn) => fn(cachedToggles));
        return cachedToggles;
      })
      .catch(() => {
        cachedToggles = cachedToggles || {};
        return cachedToggles;
      })
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
}

/** Invalidates the cached toggle map — call after an admin flips a switch
 * in the current tab so other mounted components pick it up immediately. */
export function refreshIntegrationVisibility() {
  cachedToggles = null;
  return fetchToggles();
}

/**
 * Global per-integration on/off switch (set in Master Admin ->
 * Integrations). `isEnabled(key)` defaults to `true` for any integration
 * not yet toggled off, including ones added after this hook shipped.
 */
export function useIntegrationVisibility() {
  const [toggles, setToggles] = useState(cachedToggles || {});

  useEffect(() => {
    listeners.add(setToggles);
    if (cachedToggles) {
      setToggles(cachedToggles);
    } else {
      fetchToggles().then(setToggles);
    }
    return () => listeners.delete(setToggles);
  }, []);

  const isEnabled = (key) => toggles[key] !== false;
  return { toggles, isEnabled };
}
